import { ITemplateType } from 'entities/campaign';
import { Feature } from 'entities/campaign/features';

export const campaignTypeToIcon = (type: ITemplateType | Feature) => {
  switch (type) {
    case 'Marketing Permission':
      return 'handshake-alt';
    case 'Collect email consent':
      return 'handshake-alt';
    case 'Opt in':
      return 'handshake-alt';
    case 'Cart Abandonment':
      return 'cart-arrow-down';
    case 'Browse Abandonment':
      return 'eye';
    default:
      return 'question';
  }
};
